import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { queryKeys } from '@/lib/queryKeys'
import { fetchColumnOrder, updateColumnOrder } from '@/api/columnOrder'
import { toast } from '@/stores/useToastStore'
import { getErrorMessage } from '@/utils/getErrorMessage'

export function useColumnOrder(planId: string | undefined) {
  return useQuery({
    queryKey: queryKeys.columnOrder.byPlan(planId!),
    queryFn: () => fetchColumnOrder(planId!),
    enabled: !!planId,
    staleTime: 5 * 60 * 1000,
  })
}

export function useUpdateColumnOrder(planId: string) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (columnOrder: string[]) =>
      updateColumnOrder(planId, columnOrder),
    onSuccess: data => {
      queryClient.setQueryData(queryKeys.columnOrder.byPlan(planId), data)
    },
    onError: (error: Error) => {
      toast.error(getErrorMessage(error, 'Failed to save column order'))
    },
  })
}
